<template>
  <b-form
    novalidate
    autocomplete="off"
    class="password-forgotten-form"
    @submit.prevent="onSubmit()"
  >
    <b-form-group
      class="password-forgotten-form__wrapper"
    >
      <h1
        class="password-forgotten-form__label"
        v-html="$t('headline.reset_password')"
      />
      <form-input
        id="email"
        ref="email"
        :label="$t('label.email')"
        :placeholder="$t('placeholder.enter_email')"
        class="login-form__form-input"
        variant="minimal"
        required
        type="email"
        data-testing="input_email"
        @oninput="onEmailInput"
      />

      <div
        v-if="apiErrors !== null"
        class="invalid-feedback-box"
        v-html="$t('validation.messages.' + apiErrors.msg)"
      />
      <btn
        variant="primary"
        type="submit"
        data-testing="button_submit"
        v-html="$t('button.send')"
      />
      <router-link
        to="login"
        class="password-forgotten-form__link"
        v-text="$t('button.back_to_login')"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import { BForm } from 'bootstrap-vue';
import { BFormGroup } from 'bootstrap-vue';
import Notification from '@components/Notification/Notification';
import FormInput from '@components/FormInput/FormInput';
import Btn from '@components/Btn/Btn';

/**
 * Password form
 */
export default {
  name: 'PasswordForgottenForm',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BForm,
    BFormGroup,
    Notification,
    FormInput,
    Btn
  },
  data() {
    return {
      email: null
    };
  },
  computed: {
    apiErrors() {
      return this.$store.getters['user/getError'];
    },
  },
  methods: {
    /**
     * Dispatches the Password Forgotten action
     * @event onSubmit
     * @type {Submit}
     */
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) return;

        const payload = {
          email: this.email,
        };

        this.$store.dispatch('user/sendResetPasswordLink', payload).then((data) => {
          this.$router.push({
            name: 'login',
            params: {
              redirectedFromPasswordForgotten: true
            }
          });
        });

        this.errors.clear();
      });
    },
    /**
     * Handle input event
     * @event onEmailInput
     * @type {Input}
    */
    onEmailInput(value) {
      this.email = value;
    }
  }
};
</script>

<style lang="scss">
  @import './PasswordForgottenForm';
</style>
